import React, { useEffect, useState } from 'react'
import ContentHeader from 'components/UI/ContentHeader/ContentHeader'
import useTableFixedHeader from 'hooks/useTableFixedHeader'
import { superAxiosRequest } from 'axiosApi'
import Loader from 'components/ContentBox/Global/Loader/Loader'
import THead from 'components/ContentBox/Global/ReportTable/THead'
import st from 'components/ContentBox/Global/ReportTable/Table.module.scss'
import { NavLink, useHistory } from 'react-router-dom'
import { ExcelRowsParams } from 'components/utils/ExcelExport'
import ExportExcelButton from '../ExportExcelButton/ExportExcelButton'
import useLocalStorageFilter from 'helpers/useLocalStorageFilter'
import AsideFilterStore from 'components/UI/AsideFilter/asideFilterStore'
import useLocalization from 'hooks/useLocalization'
import SearchBooks from 'components/Modules/Ebook/Books/components/SearchBooks/SearchBooks'
import FilterTextValues from 'components/UI/AsideFilter/FilterTextValues'
import AsideFilter from 'components/UI/AsideFilter/AsideFilter'
import { observer } from 'mobx-react'

const EmployeeRating = () => {
  const {
    refWrapper,
    refSticky,
    refThead,
    data,
    setData,
    isLoading,
    setIsLoading,
  } = useTableFixedHeader()

  const { translate } = useLocalization({
    section: 'ebooks',
    subsection: 'ebooks_books',
    dict: {
      edit: 'Edit',
      copy: 'Copy',
      delete: 'Delete',
      save: 'Save',
      filter: 'Filter',
      company: 'Company',
      reset_all: 'Reset all',
      apply: 'Apply',
      search: 'Search',
      start_date: 'Start date',
      end_date: 'End date',
    },
  })

  const [cols, setCols] = useState([])
  const [catalog, setCatalog] = useState({})
  const [filter, updateFilter] = useLocalStorageFilter()
  const history = useHistory()
  const {
    isOpenFilter,
    closeFilter,
    setTextValues,
    changeTextValue,
    filterTextValues,
  } = AsideFilterStore

  const filterCnf = [
    {
      type: 'select',
      label: 'Сотрудник',
      placeholder: 'Сотрудник',
      values: catalog?.responsibles?.items,
      option_label_key: 'full_name',
      sort_key: 'full_name',
      nameState: 'teacher',
    },
    {
      type: 'date_day_picker',
      nameState: ['date_from', 'date_until'],
      isRequired: true,
      label: 'Период',
    },
  ]

  const sortEvaluations = (arr, key) => arr.sort((a, b) => a[key] - b[key])

  useEffect(() => {
    setIsLoading(true)
    superAxiosRequest({
      method: 'get',
      link: 'groups/groups_catalog',
    })
      .then((res) => {
        setCatalog(res.data)
        setIsLoading(false)
      })
      .catch(() => setIsLoading(false))
  }, [])

  const parseData = (data) => {
    let newState = []
    Object.keys(data.results).forEach((teacherId) => {
      let newItem = {
        teacher_id: data.meta.teachers[teacherId].user_id,
        teacher_name: data.meta.teachers[teacherId].name,
        students: [],
      }
      Object.keys(data.results[teacherId]).forEach((studentId) => {
        let studentData = {
          student_id: data.meta.clients[studentId].user_id,
          student_name: data.meta.clients[studentId].name,
        }
        let arrayNames = [
          { name: 'Интересный урок' },
          { name: 'Использование ИД и доп. материалa' },
          { name: 'Развитие Speaking' },
          { name: 'Грамматика' },
        ]
        data.results[teacherId][studentId].forEach((reportItem) => {
          newItem.students.push({
            ...studentData,
            rate_list: [...reportItem.result],
            comments: reportItem.result.map((item, i) => ({
              name: arrayNames[i].name,
              value:
                item.comment.length === 0 ? 'Нет комментария' : item.comment,
            })),
          })
        })
      })

      newState.push(newItem)
    })
    return newState
  }

  useEffect(() => {
    if (filter?.date_from && filter?.date_until) {
      setIsLoading(true)
      let apiConf = {
        method: 'get',
        params: {
          ...filter,
          responsible: true,
        },
      }
      superAxiosRequest({
        ...apiConf,
        link: 'progress_report/teacher_report_full',
      })
        .then((res) => {
          setData([...parseData(res.data)])
          setCols([
            { name: 'Сотрудник', rowSpan: 3 },
            { name: 'Студент', rowSpan: 3 },
            ...sortEvaluations(res.data.meta.evaluations, 'id'),
            { name: 'Комментарий' },
          ])
          setIsLoading(false)
        })
        .catch(() => setIsLoading(false))
    }
  }, [filter])

  useEffect(() => {
    return AsideFilterStore.unmountFilter
  }, [])

  useEffect(() => {
    const unlisten = history.listen((location) => {
      if (location.pathname !== '/reports/employee_rating') {
        updateFilter({})
      }
    })
    return () => {
      unlisten()
    }
  }, [history, updateFilter])

  const downloadExcel = (data) => {
    import('xlsx-js-style').then((XLSX) => {
      const merges = []
      const wscols = cols.map(() => ({ wch: 30 }))
      const rows = []
      const headRow = cols.map((col) => ({
        v: col.name,
        ...ExcelRowsParams.headerRowParam,
      }))
      const tableData = data
        .map((row) => {
          return row.students.map((student) => {
            const commentLine = student.comments
              .map((comment) => `${comment.name}: ${comment.value}\n`)
              .join(' ')
            const result = [
              {
                v: row.teacher_name,
                ...ExcelRowsParams.tableRowParam.cell,
              },
              {
                v: `${student.student_name}`,
                ...ExcelRowsParams.tableRowParam.cell,
              },
              ...sortEvaluations(student.rate_list, 'evaluation_id').map(
                (rate) => ({
                  v: rate.rating_id,
                  ...ExcelRowsParams.tableRowParam.cell,
                }),
              ),
              {
                v: commentLine,
                ...ExcelRowsParams.tableRowParam.cell,
              },
            ]

            return result
          })
        })
        .flat()

      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.aoa_to_sheet([headRow, ...tableData])
      ws['!cols'] = wscols
      ws['!merges'] = merges
      ws['!rows'] = rows
      XLSX.utils.book_append_sheet(wb, ws, 'List 1')

      XLSX.writeFile(wb, 'Рейтинг по сотрудникам.xlsx')
    })
  }

  const isFilterEmpty = !filterTextValues.length

  return (
    <div>
      <ContentHeader title='Рейтинг по сотрудникам' />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          margin: '10px',
        }}
      >
        <SearchBooks
          onSearch={(text) => {
            updateFilter({ ...filter, search: text })
            changeTextValue('search', {
              key: 'search',
              label: 'Search',
              value: text,
            })
          }}
          onClear={() => {
            const { search, ...obj } = filter
            updateFilter(obj)
            setTextValues(
              filterTextValues.filter((field) => field.key !== 'search'),
            )
          }}
          translate={translate}
          placeholder={`Search...`}
          value={filter?.search || ''}
          isFilterEmpty={isFilterEmpty}
        />
        {!!filterTextValues.length && (
          <FilterTextValues
            onDelete={(key) => {
              const { [key]: _, ...obj } = filter
              updateFilter(obj)
            }}
          />
        )}
        {isOpenFilter && (
          <AsideFilter
            translate={translate}
            getFilterParams={updateFilter}
            config={filterCnf}
            filterValue={filter}
            onDropFilter={() => {
              updateFilter({})
              closeFilter()
            }}
          />
        )}
      </div>

      {isLoading ? (
        <Loader />
      ) : data && data.length > 0 ? (
        <>
          <div style={{ padding: '10px' }}>
            <ExportExcelButton data={data} downloadExcel={downloadExcel} />
          </div>
          <div className={st.tableWrapper} ref={refWrapper}>
            <div ref={refSticky} className={st.sticky}>
              <table className={st.table}>
                <THead cols={cols} />
              </table>
            </div>
            <table className={`${st.table} ${st.tbodyStriped}`}>
              <THead cols={cols} ref={refThead} />
              <tbody className={st.tbody}>
                {Array.isArray(data) && (
                  <>
                    {data.map((row, rowIdx) =>
                      row.students.map((student, sIdx) => (
                        <tr key={sIdx} className={st.bdt}>
                          {sIdx === 0 && (
                            <td
                              rowSpan={row.students.length}
                              className={st.fw600}
                              style={{ background: 'white' }}
                            >
                              <div
                                className={`${st.groupDescription} ${st.medium}`}
                              >
                                <NavLink
                                  to={'/account/' + row.teacher_id}
                                  target='_blank'
                                >
                                  {row.teacher_name}
                                </NavLink>
                              </div>
                            </td>
                          )}

                          <td
                            className={st.fw600}
                            style={{ background: 'white', width: '15%' }}
                          >
                            <div
                              className={`${st.groupDescription} ${st.medium}`}
                            >
                              <NavLink
                                to={'/account_clients/' + student.student_id}
                                target='_blank'
                              >
                                {student.student_name}
                              </NavLink>
                            </div>
                          </td>
                          {sortEvaluations(
                            student.rate_list,
                            'evaluation_id',
                          ).map((rateItem, rIdx) => (
                            <td
                              key={rIdx}
                              className={st.fw600}
                              style={{
                                background: 'white',
                                width: '11%',
                                textAlign: 'center',
                              }}
                            >
                              {rateItem.rating_id}
                            </td>
                          ))}
                          <td style={{ background: 'white', width: '19%' }}>
                            {student.comments.map((comment, comIdx) => (
                              <div key={comIdx} className=''>
                                <strong>{`${comment.name}:`} </strong>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: comment.value.replace(
                                      /&nbsp;/g,
                                      '',
                                    ),
                                  }}
                                />
                              </div>
                            ))}
                          </td>
                        </tr>
                      )),
                    )}
                  </>
                )}
              </tbody>
            </table>
          </div>
        </>
      ) : (
        <h1 className={st.noData}>Нет данных для отображения!</h1>
      )}
    </div>
  )
}

export default observer(EmployeeRating)
